
export const environment = {
    production: false,
    apiUrl: 'https://api.bybrickelevate.xyz/happy/api/',
    loginUrl: 'https://api.bybrickelevate.xyz/happy/api/token',    
    registerLink: 'https://identity.bybrickelevate.xyz/identity/account/register',
    recoverLink: 'https://identity.bybrickelevate.xyz/identity/account/forgotpassword'
};